import { Component, OnInit, Inject, Output,Input, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { CanserModel } from 'src/app/models/CanserModel';
import { CanserService } from 'src/app/services/CanserService';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import swal from 'sweetalert2';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { PatientInfoComponent } from '../patient-info/patient-info.component';
import { RoundAndClinicsViweComponent } from '../round-and-clinics-viwe/round-and-clinics-viwe.component';


@Component({
  selector: 'app-doctor-observation-tab',
  templateUrl: './doctor-observation-tab.component.html',
  styleUrls: ['./doctor-observation-tab.component.css']
})
export class DoctorObservationTabComponent implements OnInit {

  Patientcode = '';
  Patientname = '';
  visitdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  birthDate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  dateEntry1 =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  paAge = 0;
  gender = ''
  cancerID = '';
  pathology ='';
  cancerlist : CanserModel[]=[];
  disablepharnacy = false;
  chkuser ='';
  compcode = '1';
  step = 0;
  doctorname
  @Output() submitClicked = new EventEmitter<any>();
  // @Output()  PaShared = new EventEmitter<string>();
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  constructor(public CanserService : CanserService,
    public storage: LocalStorageService,
    private dialogref: MatDialog,
    public dataBankService : DataBankService,
    public doctorService :DoctorsService,
    public patient :DatabankModel,
    )  {
      this.retrievePatient();
    }

  ngOnInit(): void {
    this.retriveCancersLookupTop();
    this.Patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.visitdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.retrievePatient();
    if(this.storage.retrieve('stgGroup') =='4' || this.storage.retrieve('stgGroup') =='8'){
      this.disablepharnacy = true;
    }
  }
  retriveCancersLookupTop() {
    this.CanserService.getCancerLookupTop().subscribe((data:CanserModel[])=>{
  for(let i=0 ; i <data.length; i++)
  {this.cancerlist[i]=data[i];}
 })
  }
   retrievePatient() {
    debugger
          this.dataBankService.getPatient(this.Patientcode,'1').subscribe((data: DatabankModel) => {
          this.storage.store('stgPatientCode',data.patientCode)
          this.storage.store('stgPatientName',data.patientFName);
          this.storage.store('stgConsultant',data.docCode);
          this.storage.store('stgcancerIDOrginam',this.cancerID)
          this.doctorService.getdoctors(data.docCode,'1').subscribe((data1:DoctorsModel)=>{
            this.doctorname=data1.docName;
           })
          this.Patientname = data.patientFName;

        this.paAge = Number(data.ageYear);
        this.birthDate =formatDate(data.birthDate,'yyyy-MM-dd','en') ;
        this.gender = data.gender;

        this.cancerID = data.cancerID;
        this.dateEntry1 = formatDate(data.dateEntry,'yyyy-MM-dd','en');

        this.storage.store('stgPatientCode', this.Patientcode);
         this.storage.store('stgcancerIDOrginam', this.cancerID);
        console.log("A7A:",this.storage.retrieve('stgcancerIDOrginam'))
        });

      }
  OpenPatientDialog(){
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent,
    {
      data: {
        dataKey: this.patient
      },
       width: '55vw',
  });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.Patientcode = result.patientCode;
      this.storage.store('stgPatientCode', this.Patientcode);
      this.storage.store('stgcancerID',this.cancerID)
      this.retrievePatient();
      window.location.reload();
    });

}
Retrive_All(){
  this.storage.store('stgPatientCode', this.Patientcode);
  this.storage.store('stgcancerID',this.cancerID)
  window.location.reload();
}
PutPatient(){
    //this.storage.store('stgPatientCode','20230759');
}

OpenPreparation() {
  this.storage.store('stgPatientCode',this.Patientcode);

//  this.PaShared.emit(this.Patientcode);
 ///this.storage.store('stgDoctorCode','');
 // this.storage.store('stgDocumentDate',this.patdate);



}
PatientInfo(){
    const dialogRef = this.dialogref.open(PatientInfoComponent,
        {
          data: {
            dataKey: this.patient,
            patientcode : this.Patientcode
          },
          width: '70vw',
          height: '20vw',

        });
        dialogRef.afterClosed().subscribe(result => {
        });

        const dialogSubmitSubscription =
           dialogRef.componentInstance.submitClicked.subscribe(result => {
            this.Patientcode = result.patientCode;



          });

}
MesgWarrning(){

  swal({
    title: 'Check User',
    text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
    type: 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK',
    //cancelButtonText: 'No, keep it',
  })
  ;

}

RoundAndClinicOpen(){

    const dialogRef = this.dialogref.open(RoundAndClinicsViweComponent,
        {
          width: '75%',
          height: '75%',
        });
        dialogRef.afterClosed().subscribe(result => {
        });

        const dialogSubmitSubscription =
           dialogRef.componentInstance.submitClicked.subscribe(result => {
          });

}
}

